import { render } from "./FoolTools.vue?vue&type=template&id=666b111e&scoped=true&ts=true"
import script from "./FoolTools.vue?vue&type=script&lang=ts"
export * from "./FoolTools.vue?vue&type=script&lang=ts"

import "./FoolTools.vue?vue&type=style&index=0&id=666b111e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b111e"]])

export default __exports__